import {Injectable} from '@angular/core';
import {SettingsEnum} from 'app/_interfaces/settings.interface';
import {Store} from '@ngrx/store';
import * as journalActions from '../../../journal/src/_actions/journal.actions';
import * as fromJournal from '../../../journal/src/_selectors/journal.selectors';
import {withLatestFrom} from 'rxjs/operators';

type SettingsMap = Map<string, any>;

@Injectable({
	providedIn: 'root'
})
export class SettingsService {
	private stack: SettingsMap = new Map();

	constructor(
		private store: Store
	) {
		this.store.select(fromJournal.selectJournalSettings).pipe(
			withLatestFrom(this.store.select(fromJournal.selectGeneralSettings))
		).subscribe(([journal, general]) => {
			const settingsArr = Object.values(journal || {}).concat(Object.values(general || {}));
			this.stack = new Map<string, any>(
				settingsArr.map(row => {
					return [row.key, {
						key: row.key,
						value: row.value
					}];
				})
			);
		});
	}

	getValue(key: string) {
		if (!this.stack.get(key)) return;
		return this.stack.get(key).value;
	}

	setValue(key: string, value: any) {
		if (this.stack.get(key) === value) return;
		this.stack.set(key, value);
		if (key.includes(SettingsEnum.journal)) {
			this.store.dispatch(journalActions.saveSingleKey({key, value}));
		}
	}
}
